module.exports = __webpack_public_path__ + "img/yp_logo.f779249a.svg";